// extracted by mini-css-extract-plugin
export default {"tooltipContent":"tooltipContent__gHvj-","light":"light__3TyHj","dark":"dark__b0rS1"};
    if(module.hot) {
      // 1792680999403
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  